import { call, put, takeLatest, all } from 'redux-saga/effects'
import { handleApiErrors } from '../../lib/api-errors'
import * as Constants from './constants'
import * as Actions from './actions'

const contestRequestUrl = `${process.env.REACT_APP_WEB_API}/api/v1/contest/get-all-contest`;
const draftRequestUrl = `${process.env.REACT_APP_WEB_API}/api/v1/contest/draft-contest`;

function handleRequest (request) {
  return request
    .then(handleApiErrors)
    .then(response => response.json())
    .then(json => json)
    .catch((error) => { throw error })
}

function contestRequestApi ({ filters }) {
  const url = new URL(contestRequestUrl);
  url.search = new URLSearchParams(filters);
  const request = fetch(url, {
    method: 'GET',
    headers: {
      authorization: localStorage.getItem("jwtToken"),
      'Content-Type': 'application/json'
    },
  })

  return handleRequest(request)
}
function* contestRequestFlow (action) {
  try {
    const contest = yield call(contestRequestApi, action)
    yield put(Actions.contestSuccess(contest))
  } catch (error) {
    yield put(Actions.contestError(error))
  }
}

function draftRequestApi ({ contestId, toDraft }) {
  const request = fetch(draftRequestUrl, {
    method: 'POST',
    headers: {
      authorization: localStorage.getItem("jwtToken"),
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({ contest_id: contestId, to_draft: toDraft }),
  })

  return handleRequest(request)
}
function* draftRequestFlow (action) {
  try {
    const result = yield call(draftRequestApi, action)
    yield put(Actions.draftSuccess(result))
  } catch (error) {
    yield put(Actions.draftError(error))
  }
}

function* contestWatcher () {
  yield all([
    takeLatest(Constants.CONTEST_REQUEST, contestRequestFlow),
    takeLatest(Constants.DRAFT_REQUEST, draftRequestFlow),
  ])
}

export default contestWatcher
